export const SKILL_TYPE = 'skillType';

export const SOFTWARE = 'SOFTWARE';
export const DOCUMENTS = 'DOCUMENTS';
export const PROFESSIONAL_SKILL = 'PROFESSIONAL_SKILL';
